import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page.component';
import { Router } from '@angular/router';
import { PeopleService } from '../../shared/services';

@Component({
    templateUrl: './settings.component.html',
    standalone: false
})
export class SettingsPageComponent extends BasePageComponent implements OnInit {
  constructor(private router: Router, location: Location, private peopleService: PeopleService) {
    super(location);
  }

  ngOnInit(): void {
    this.peopleService.getCurrent().subscribe((data) => {
      this.currentPerson = data;
    });
  }

  goToBack(): void {
    this.router.navigate([this.appRoute]);
  }
}
